import { keyframes } from "@mui/material";
import { DASHBOARD_TRANSITION_DURATION_MS } from "web_myplann/Dashboard/Utils/dashboardLayout";

export const DOT_SIZE = 8;
export const PILL_WIDTH = 24;

const DOT_GAP = 6.4;
const PILL_EXTRA = PILL_WIDTH - DOT_SIZE;

export const DOT_STEP = DOT_SIZE + DOT_GAP;

export const DOT_EASING = "cubic-bezier(0.34, 1.56, 0.64, 1)";

export const getDotOffset = (dotIndex: number, activeIndex: number) =>
	dotIndex * DOT_STEP + (dotIndex > activeIndex ? PILL_EXTRA : 0);

export const getRowWidth = (length: number) =>
	(length - 1) * DOT_STEP + PILL_WIDTH;

const PILL_MAX_STRETCH_STEPS = 2;
const PILL_STRETCH_PER_STEP = 0.35;
const PILL_LANDING_SQUASH = 0.92;

export const getPillAnimation = (fromIndex: number, toIndex: number) => {
	const from = fromIndex * DOT_STEP;
	const to = toIndex * DOT_STEP;
	const mid = (from + to) / 2;
	const stretch =
		1 +
		Math.min(Math.abs(toIndex - fromIndex), PILL_MAX_STRETCH_STEPS) *
			PILL_STRETCH_PER_STEP;

	const slide = keyframes`
		0% { transform: translateX(${from}px) scaleX(1); }
		45% { transform: translateX(${mid}px) scaleX(${stretch}); }
		85% { transform: translateX(${to}px) scaleX(${PILL_LANDING_SQUASH}); }
		100% { transform: translateX(${to}px) scaleX(1); }
	`;

	return `${slide} ${DASHBOARD_TRANSITION_DURATION_MS}ms ease-in-out`;
};
